{
  "definitions": {
    "intro": "ช่องเพิ่มเติมในฟอร์มสินค้า (เช่น คำอธิบายยาว ปีที่วางขาย) เพิ่มที่นี่แล้วฟอร์มสินค้าจะแสดงทันที",
    "add": "เพิ่มข้อมูลเพิ่มเติม",
    "new_title": "ข้อมูลเพิ่มเติมใหม่",
    "drawer_hint": "สิ่งที่พนักงานกรอกในหน้าสินค้า จะยังไม่ขึ้นเว็บจนกว่าสินค้าจะใช้",
    "save": "บันทึกช่องนี้",
    "saved": "บันทึก “{{name}}” แล้ว — ฟอร์มสินค้าแสดงแล้ว",
    "deleted": "ลบ “{{name}}” แล้ว",
    "delete": "ลบ",
    "delete_title": "ลบ “{{name}}” ใช่ไหม?",
    "delete_consequence": "ช่องนี้จะหายจากฟอร์มสินค้า ถ้ามีสินค้าที่กรอกค่าไว้แล้ว ระบบจะไม่ลบ",
    "in_use_title": "ช่องนี้ยังถูกใช้อยู่",
    "in_use_body_other": "มีสินค้า {{count}} รายการที่กรอกช่องนี้ไว้ จึงไม่ได้ลบ ให้ลบค่าในสินค้าเหล่านั้นก่อน",
    "in_use_ok": "ตกลง",
    "type_in_use_other": "มีสินค้า {{count}} รายการที่กรอกค่าไว้แล้ว จึงเปลี่ยนชนิดคำตอบไม่ได้ ใช้ชนิดเดิมหรือสร้างช่องใหม่",
    "type_change_warning": "กำลังเปลี่ยนชนิดคำตอบ ถ้ามีสินค้าที่กรอกค่าไว้แล้ว ระบบจะไม่ยอมเปลี่ยนและบอกจำนวน",
    "duplicate_key": "มีช่องที่ใช้ชื่อรหัสนี้แล้ว เลือกชื่อรหัสอื่น",
    "all_types": "ทุกประเภท",
    "position_cell": "{{position}} (ส่วนที่ {{part}} ของฟอร์ม)",
    "columns": {
      "label": "ชื่อ",
      "key": "ชื่อรหัส",
      "type": "ชนิดคำตอบ",
      "owner": "เป็นของ",
      "position": "ตำแหน่งในฟอร์ม",
      "applies_to": "แสดงกับ",
      "ebay": "ชื่อบน eBay"
    },
    "flags_short": {
      "filterable": "กรองบนเว็บ",
      "searchable": "ค้นหาได้",
      "showOnStorefront": "แสดงบนเว็บ"
    },
    "flags": {
      "filterable": "ลูกค้ากรองสินค้าด้วยช่องนี้บนเว็บได้",
      "searchable": "ช่องค้นหาบนเว็บหาสินค้าจากช่องนี้ได้",
      "showOnStorefront": "แสดงในหน้าสินค้าบนเว็บ"
    },
    "fields": {
      "label_en": "ชื่อ (อังกฤษ)",
      "label_en_hint": "ชื่อที่พนักงานเห็นเหนือช่อง เช่น “Detail”",
      "label_ja": "ชื่อ (ญี่ปุ่น)",
      "label_th": "ชื่อ (ไทย)",
      "label_zh-Hant": "ชื่อ (จีนตัวเต็ม)",
      "label_zh-Hans": "ชื่อ (จีนตัวย่อ)",
      "key": "ชื่อรหัส",
      "key_hint": "เติมจากชื่อภาษาอังกฤษให้เอง บันทึกเป็น {{key}} — ใช้ในไฟล์นำเข้า",
      "key_locked": "บันทึกแล้วเปลี่ยนชื่อรหัสไม่ได้ (ไฟล์และสินค้าใช้อยู่)",
      "owner": "เป็นของ",
      "type": "ชนิดคำตอบ",
      "position": "ตำแหน่งในฟอร์มสินค้า",
      "position_hint": "ใส่ตัวเลข 5 = ข้างหมวดย่อย, เลขอื่น = ในส่วนที่ {{part}} “รายละเอียด” เลขน้อยขึ้นก่อน",
      "position_hint_other": "ใส่ตัวเลข เลขน้อยขึ้นก่อน",
      "applies_to": "แสดงกับสินค้าประเภทนี้",
      "applies_to_hint": "ไม่ติ๊กเลย = ทุกประเภท",
      "use": "บนเว็บ",
      "rules": "กฎของคำตอบ",
      "ebay_aspect": "ชื่อบน eBay (ไว้ใช้ภายหลัง)",
      "ebay_aspect_hint": "แค่เก็บไว้สำหรับตอนเชื่อม eBay ในเฟสถัดไป ตอนนี้ไม่ส่งอะไร"
    },
    "owners": {
      "product": "ตัวสินค้า",
      "variant": "แต่ละตัวเลือกของสินค้า (กล่อง ซอง…)",
      "collection": "หน้าคอลเลกชัน"
    },
    "types": {
      "single_line_text": "ข้อความสั้น (บรรทัดเดียว)",
      "multi_line_text": "ข้อความยาว (หลายบรรทัด)",
      "rich_text": "ข้อความจัดรูปแบบ (ตัวหนา รายการ)",
      "integer": "จำนวนเต็ม",
      "decimal": "ตัวเลขมีทศนิยม",
      "boolean": "ใช่ / ไม่ใช่",
      "date": "วันที่",
      "url": "ลิงก์เว็บ",
      "json": "ข้อมูลแบบมีโครงสร้าง (ขั้นสูง)",
      "list_text": "รายการข้อความสั้น",
      "file_reference": "ไฟล์หรือรูป 1 อย่าง",
      "list_file_reference": "ไฟล์หรือรูปหลายอย่าง",
      "reference": "ลิงก์ไปสินค้าอื่น"
    },
    "rules": {
      "required": "ต้องกรอกก่อนบันทึกสินค้า",
      "choices": "คำตอบที่เลือกได้",
      "choices_hint": "บรรทัดละ 1 คำตอบ ว่าง = เขียนอะไรก็ได้",
      "min": "ตัวเลขต่ำสุด",
      "max": "ตัวเลขสูงสุด",
      "max_length": "ความยาวข้อความสูงสุด (ตัวอักษร)",
      "regex": "รูปแบบที่ข้อความต้องเป็น",
      "regex_hint": "ขั้นสูง — ถ้าไม่แน่ใจให้เว้นว่าง",
      "max_items": "จำนวนรายการสูงสุด"
    },
    "problems": {
      "required": "กรุณากรอกช่องนี้",
      "key_format": "ใช้ตัวพิมพ์เล็ก a–z ตัวเลข และ _ เท่านั้น ขึ้นต้นด้วยตัวอักษร",
      "position_range": "ใช้ตัวเลข 0 ถึง 999",
      "not_number": "ใส่ตัวเลข เช่น 8",
      "min_above_max": "ตัวเลขสูงสุดต้องไม่น้อยกว่าตัวเลขต่ำสุด",
      "not_whole": "ใส่จำนวนเต็ม เช่น 200",
      "pattern_invalid": "อ่านรูปแบบนี้ไม่ได้ ถ้าไม่แน่ใจให้เว้นว่าง",
      "choices_not_whole": "คำตอบที่เลือกได้ต้องเป็นจำนวนเต็มทั้งหมด"
    }
  },
  "categories": {
    "intro": "กลุ่มสินค้าบนเว็บ (สูงสุด 3 ชั้น เช่น สินค้าซีล › กล่องบูสเตอร์) เปลี่ยนลำดับด้วย ▲ ▼",
    "add": "เพิ่มหมวดหมู่",
    "new_title": "หมวดหมู่ใหม่",
    "save": "บันทึกหมวดหมู่",
    "saved": "บันทึกหมวดหมู่ “{{name}}” แล้ว",
    "deleted": "ลบหมวดหมู่ “{{name}}” แล้ว",
    "delete": "ลบ",
    "delete_title": "ลบหมวดหมู่ “{{name}}” ใช่ไหม?",
    "delete_consequence": "หมวดหมู่จะหายจากเมนูเว็บ หมวดที่ยังมีสินค้าหรือหมวดย่อยจะไม่ถูกลบ",
    "in_use_title": "หมวดหมู่นี้ยังถูกใช้อยู่",
    "in_use_body": "ยังมีสินค้า {{products}} รายการ และหมวดย่อย {{children}} หมวด ย้ายไปหมวดอื่นก่อน — หรือซ่อนหมวดนี้แทน",
    "too_deep": "หมวดหมู่ซ้อนได้สูงสุด {{max}} ชั้น เลือกหมวดแม่ที่อยู่สูงกว่า",
    "duplicate": "มีหมวดอื่นใช้ชื่อในลิงก์นี้แล้ว เปลี่ยนเล็กน้อย",
    "top_level": "— ชั้นบนสุด (ไม่มีหมวดแม่) —",
    "shown": "แสดง",
    "hidden": "ซ่อน",
    "move_up": "เลื่อน {{name}} ขึ้น",
    "move_down": "เลื่อน {{name}} ลง",
    "add_child": "เพิ่มหมวดใต้ {{name}}",
    "columns": {
      "name": "ชื่อ",
      "slug": "ชื่อในลิงก์เว็บ",
      "applies_to": "สำหรับ",
      "active": "บนเว็บ",
      "order": "ลำดับ"
    },
    "fields": {
      "name_en": "ชื่อ (อังกฤษ)",
      "name_ja": "ชื่อ (ญี่ปุ่น)",
      "name_th": "ชื่อ (ไทย)",
      "name_zh-Hant": "ชื่อ (จีนตัวเต็ม)",
      "name_zh-Hans": "ชื่อ (จีนตัวย่อ)",
      "slug": "ชื่อในลิงก์เว็บ",
      "slug_hint": "เติมจากชื่อภาษาอังกฤษ: …/collections/{{name}}",
      "parent": "อยู่ในหมวดไหน",
      "parent_hint": "หมวดหลักให้เลือก “ชั้นบนสุด”",
      "applies_to": "สำหรับสินค้าประเภทนี้",
      "applies_to_hint": "ฟอร์มสินค้าจะเสนอหมวดนี้เฉพาะประเภทที่ติ๊ก ไม่ติ๊ก = ทุกประเภท",
      "active": "แสดงหมวดนี้บนเว็บ"
    },
    "problems": {
      "required": "กรุณากรอกช่องนี้",
      "slug_format": "ใช้ตัวพิมพ์เล็ก a–z ตัวเลข และ - เท่านั้น (ห้ามเว้นวรรค)"
    }
  },
  "brands": {
    "intro": "ผู้ผลิตสินค้า (ซองใส่การ์ด กล่องเด็ค…) พร้อมโลโก้",
    "add": "เพิ่มแบรนด์",
    "new_title": "แบรนด์ใหม่",
    "save": "บันทึกแบรนด์",
    "saved": "บันทึกแบรนด์ “{{name}}” แล้ว",
    "deleted": "ลบแบรนด์ “{{name}}” แล้ว",
    "delete": "ลบ",
    "delete_title": "ลบแบรนด์ “{{name}}” ใช่ไหม?",
    "delete_consequence": "แบรนด์จะหายไป แบรนด์ที่สินค้ายังใช้อยู่จะไม่ถูกลบ",
    "in_use_title": "แบรนด์นี้ยังถูกใช้อยู่",
    "in_use_body_other": "มีสินค้า {{count}} รายการใช้แบรนด์นี้ จึงไม่ได้ลบ",
    "duplicate": "มีแบรนด์ที่ใช้ชื่อในลิงก์นี้แล้ว",
    "has_logo": "มีโลโก้",
    "no_logo": "ไม่มีโลโก้",
    "updated": "แก้ไขล่าสุด",
    "fields": {
      "name": "ชื่อแบรนด์",
      "logo": "โลโก้"
    }
  }
}
